import styled from 'styled-components';

import { media } from '@theme/media';
import { FONT_SIZE, LETTER_SPACING, typography } from '@theme/font';

import { containerStyles } from '../pdp.styles';

export const Container = styled.div`
  ${containerStyles};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${media.tablet} {
    flex-direction: row;
  }
`;

export const SketchContainer = styled.div`
  width: 100%;

  ${media.tablet} {
    width: 50%;
    max-width: 300px;
  }
`;

export const SketchDescription = styled.div`
  ${typography({ size: FONT_SIZE.XS, spacing: LETTER_SPACING.M })};
  width: 50%;
  padding: 50px 0 0;

  ${media.tablet} {
    padding: 0 0 0 50px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    position: relative;
    padding-left: 12px;

    &:before {
      content: '\\00B7';
      position: absolute;
      left: 0;
    }
  }
`;
